import { Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

export const HERLIGHEDER_ROUTES: Routes = [
  { path: `shop/boern-117c1.html`, redirectTo: `${environment.urls.products}/børne-menu-2176` },
  { path: `shop/broed-121c1.html`, redirectTo: `${environment.urls.products}/børne-menu-2176` },
  { path: `shop/brunch-95s1.html`, redirectTo: `${environment.urls.products}/traditionel-brunch-2173` },
  {
    path: `shop/buffet med dessert 285p.html`,
    redirectTo: `${environment.urls.products}/buffet-med-dessert-2050`,
  },
  { path: `shop/buffet-286p.html`, redirectTo: `${environment.urls.products}/buffet-1940` },
  { path: `shop/buffeter-94s1.html`, redirectTo: `${environment.urls.products}/buffeter` },
  { path: `shop/buffet-med-2-292p.html`, redirectTo: `${environment.urls.products}/buffet-1940` },
  { path: `shop/buffet-med-dessert-285p.html`, redirectTo: `${environment.urls.products}/buffet-med-dessert-2050` },
  { path: `shop/buffet-med-forret-283p.html`, redirectTo: `${environment.urls.products}/buffet-med-forret-1992` },
  { path: `shop/buffet-med-forret-284p.html`, redirectTo: `${environment.urls.products}/buffet-med-forret-1992` },
  { path: `shop/flaeskesteg-med-svaer-401p.html`, redirectTo: `${environment.urls.products}/produkter/flæskesteg-med-svær-1922` },
  { path: `shop/gammeldags-30c1.html`, redirectTo: `${environment.urls.products}/gammeldags-oksesteg-1923` },
  { path: `shop/konfirmation-48c1.html`, redirectTo: `${environment.urls.products}/konfirmations-menu-2019` },
  { path: `shop/konfirmationsmenu-357p.html`, redirectTo: `${environment.urls.products}/konfirmations-menu-2019` },
  { path: `shop/luksus-brunch-398p.html`, redirectTo: `${environment.urls.products}/luksus-brunch-1919` },
  { path: `shop/luksus-brunch-398p.html`, redirectTo: `${environment.urls.products}/luksus-brunch-1919` },
  { path: `shop/natmad-119c1.html`, redirectTo: `${environment.urls.products}/natmad-2054` },
  { path: `shop/oksefiletvalgfri-dessert-319p.html`, redirectTo: `${environment.urls.products}/buffet-med-dessert-2050` },
  { path: `shop/oksemoerbradforret-og-337p.html`, redirectTo: `${environment.urls.products}/buffet-med-dessert-2050` },
  { path: `shop/oksesteg-med-valgfri-314p.html`, redirectTo: `${environment.urls.products}/buffet-med-dessert-2050` },
  { path: `shop/studenter-menu-tilbud-382p.html`, redirectTo: `${environment.urls.products}/studentermenu-1921` },
  { path: `shop/studentertilbud-91s1.html`, redirectTo: `${environment.urls.products}/studentermenu-1921` },
  { path: `shop/svinekamforret-og-dessert-333p.html`, redirectTo: `${environment.urls.products}/buffet-med-forret-og-dessert-1993` },
  { path: `shop/svinekam-som-vildtforret-336p.html`, redirectTo: `${environment.urls.products}/buffet-med-forret-og-dessert-1993` },
  { path: `shop/svinekam-stegt-som-311p.html`, redirectTo: `${environment.urls.products}/buffet-med-forret-og-dessert-1993` },
  { path: `shop/tapas-116c1.html`, redirectTo: `${environment.urls.products}/tapas-1920` },
  { path: `shop/traditionel-brunch-med-298p.html`, redirectTo: `${environment.urls.products}/traditionel-brunch-2173` },

  { path: `shop/6-retter-52c1.html`, redirectTo: `${environment.urls.products}/produkter/6-retter-2650` },
  { path: `shop/bestil-laekker-menu-443p.html`, redirectTo: `${environment.urls.products}/produkter/buffet-med-forret-og-dessert-1993` },
  { path: `shop/den-store-sult-432p.html`, redirectTo: `${environment.urls.products}/produkter/buffet-med-forret-og-dessert-1993` },
  { path: `shop/farseret-kalkunbryst-309p.html`, redirectTo: `${environment.urls.products}/produkter/farseret-kalkunbryst-2653` },
  { path: `shop/farseret-kalkunbrystforret-334p.html`, redirectTo: `${environment.urls.products}/produkter/farseret-kalkunbryst-2653` },
  { path: `shop/fredags-menu-302p.html`, redirectTo: `${environment.urls.products}/produkter/fredags-menu-2654` },
  { path: `shop/gaeste-menu-331p.html`, redirectTo: `${environment.urls.products}/produkter/gaeste-menu-2655` },
  { path: `shop/gammeldags-oksesteg-med-440p.html`, redirectTo: `${environment.urls.products}/produkter/gammeldags-oksesteg-1923` },
  { path: `shop/graesk-tema-379p.html`, redirectTo: `${environment.urls.products}/produkter/græsk-tema-2656` },
  { path: `shop/grillbuffet-175-med-430p.html`, redirectTo: `${environment.urls.products}/produkter/buffet-med-forret-og-dessert-1993` },
  { path: `shop/hannes-buffet-326p.html`, redirectTo: `${environment.urls.products}/produkter/buffet-med-forret-og-dessert-1993` },
  { path: `shop/italiensk-tema-300p.html`, redirectTo: `${environment.urls.products}/produkter/Italiensk%20tema%20buffet-2657` },
  { path: `shop/jubilaeumsmenu-396p.html`, redirectTo: `${environment.urls.products}/produkter/buffet-med-forret-og-dessert-1993` },
  {
    path: `shop/kalvestegforret-og-dessert-335p.html`,
    redirectTo: `${environment.urls.products}/produkter/kalvefilet%2Bvalgfri-dessert-2659`,
  },
  { path: `shop/klassikere-111s1.html`, redirectTo: `${environment.urls.products}/produkter/klassikere` },
  { path: `shop/koldt-bord-375p.html`, redirectTo: `${environment.urls.products}/produkter/koldt-bord-2660` },
  { path: `shop/koldt-bord-stor-376p.html`, redirectTo: `${environment.urls.products}/produkter/koldt-bord-stor-2661` },
  { path: `shop/madbroed-293p.html`, redirectTo: `${environment.urls.products}/produkter/madbrød-1925` },
  { path: `shop/mexicansk-tema-301p.html`, redirectTo: `${environment.urls.products}/produkter/mexicansk-tema-2662` },
  { path: `shop/nytaarsmenu-281p.html`, redirectTo: `${environment.urls.products}/produkter/nytårsmenu-2649` },
  { path: `shop/oel-tema-menu-377p.html`, redirectTo: `${environment.urls.products}/produkter/øl-tema-menu-2663` },
  { path: `shop/receptionsmenu-295p.html`, redirectTo: `${environment.urls.products}/produkter/6-retter-2650` },
  { path: `shop/receptionsmenu-296p.html`, redirectTo: `${environment.urls.products}/produkter/6-retter-2650` },
  { path: `shop/receptionsmenu-366p.html`, redirectTo: `${environment.urls.products}/produkter/6-retter-2650` },
  { path: `shop/tunmousse-med-stenbiderrogn-443p.html`, redirectTo: `${environment.urls.products}/produkter/buffet-med-forret-1992` },
  { path: `-o`, redirectTo: `${environment}` },

  { path: `shop/frontpage.html`, redirectTo: `` },
  { path: `shop/6-retter-52c1.html`, redirectTo: `` },
  { path: `shop/bestil-laekker-menu-443p.html`, redirectTo: `` },
  { path: `shop/den-store-sult-432p.html`, redirectTo: `` },
  { path: `shop/farseret-kalkunbryst-309p.html`, redirectTo: `` },
  { path: `shop/farseret-kalkunbrystforret-334p.html`, redirectTo: `` },
  { path: `shop/fredags-menu-302p.html`, redirectTo: `` },
  { path: `shop/gaeste-menu-331p.html`, redirectTo: `` },
  { path: `shop/gammeldags-oksesteg-med-440p.html`, redirectTo: `` },
  { path: `shop/graesk-tema-379p.html`, redirectTo: `` },
  { path: `shop/grillbuffet-175-med-430p.html`, redirectTo: `` },
  { path: `shop/hannes-buffet-326p.html`, redirectTo: `` },
  { path: `shop/italiensk-tema-300p.html`, redirectTo: `` },
  { path: `shop/jubilaeumsmenu-396p.html`, redirectTo: `` },
  { path: `shop/kalvestegforret-og-dessert-335p.html`, redirectTo: `` },
  { path: `shop/klassikere-111s1.html`, redirectTo: `` },
  { path: `shop/koldt-bord-375p.html`, redirectTo: `` },
  { path: `shop/koldt-bord-stor-376p.html`, redirectTo: `` },
  { path: `shop/madbroed-293p.html`, redirectTo: `` },
  { path: `shop/mexicansk-tema-301p.html`, redirectTo: `` },
  { path: `shop/nytaarsmenu-281p.html`, redirectTo: `` },
  { path: `shop/oel-tema-menu-377p.html`, redirectTo: `` },
  { path: `shop/receptionsmenu-295p.html`, redirectTo: `` },
  { path: `shop/receptionsmenu-296p.html`, redirectTo: `` },
  { path: `shop/receptionsmenu-366p.html`, redirectTo: `` },
  { path: `shop/tunmousse-med-stenbiderrogn-443p.html`, redirectTo: `` },

  { path: `shop/buffeter-94s1.html`, redirectTo: `` },
  { path: `shop/brunch-95s1.html`, redirectTo: `` },
  { path: `shop/traditionel-brunch-med-298p.html`, redirectTo: `` },
  { path: `shop/tapas-116c1.html`, redirectTo: `` },
  { path: `shop/natmad-119c1.html`, redirectTo: `` },
  { path: `shop/luksus-brunch-398p.html`, redirectTo: `` },
  { path: `shop/konfirmation-48c1.html`, redirectTo: `` },
  { path: `shop/konfirmationsmenu-357p.html`, redirectTo: `` },
  { path: `shop/gammeldags-30c1.html`, redirectTo: `` },
  { path: `shop/flaeskesteg-med-svaer-401p.html`, redirectTo: `` },
  { path: `shop/buffet-med-forret-283p.html`, redirectTo: `` },
  { path: `shop/buffet-med-forret-284p.html`, redirectTo: `` },
  { path: `shop/svinekamforret-og-dessert-333p.html`, redirectTo: `` },
  { path: `shop/svinekam-som-vildtforret-336p.html`, redirectTo: `` },
  { path: `shop/svinekam-stegt-som-311p.html`, redirectTo: `` },
  { path: `shop/buffet med dessert 285p.html`, redirectTo: `` },
  { path: `shop/buffet-med-dessert-285p.html`, redirectTo: `` },
  { path: `shop/oksefiletvalgfri-dessert-319p.html`, redirectTo: `` },
  { path: `shop/oksemoerbradforret-og-337p.html`, redirectTo: `` },
  { path: `shop/oksesteg-med-valgfri-314p.html`, redirectTo: `` },
  { path: `shop/buffet-286p.html`, redirectTo: `` },
  { path: `shop/buffet-med-2-292p.html`, redirectTo: `` },
  { path: `shop/boern-117c1.html`, redirectTo: `` },
  { path: `shop/broed-121c1.html`, redirectTo: `` },
  { path: `shop/studenter-menu-tilbud-382p.html`, redirectTo: `` },
  { path: `shop/studentertilbud-91s1.html`, redirectTo: `` },
  { path: `shop/6-retter-52c1.html`, redirectTo: `` },
  { path: `shop/aspargessuppe-342p.html`, redirectTo: `` },
  { path: `shop/bestil-laekker-menu-443p.html`, redirectTo: `` },
  { path: `shop/broed-buffet-til-399p.html`, redirectTo: `` },
  { path: `shop/den-store-sult-432p.html`, redirectTo: `` },
  { path: `shop/den-traditionelle-julebuffet-341p.html`, redirectTo: `` },
  { path: `shop/den-utraditionelle-julebuffet-325p.html`, redirectTo: `` },
  { path: `shop/farseret-kalkunbryst-309p.html`, redirectTo: `` },
  { path: `shop/farseret-kalkunbrystforret-334p.html`, redirectTo: `` },
  { path: `shop/fredags-menu-302p.html`, redirectTo: `` },
  { path: `shop/gaeste-menu-331p.html`, redirectTo: `` },
  { path: `shop/gammeldags-oksesteg-med-440p.html`, redirectTo: `` },
  { path: `shop/graesk-tema-379p.html`, redirectTo: `` },
  { path: `shop/grillbuffet-175-med-430p.html`, redirectTo: `` },
  { path: `shop/hannes-buffet-326p.html`, redirectTo: `` },
  { path: `shop/italiensk-tema-300p.html`, redirectTo: `` },
  { path: `shop/jubilaeumsmenu-396p.html`, redirectTo: `` },
  { path: `shop/jule-buffet-28s1.html`, redirectTo: `` },
  { path: `shop/kalvefiletvalgfri-dessert-318p.html`, redirectTo: `` },
  { path: `shop/kalvestegforret-og-dessert-335p.html`, redirectTo: `` },
  { path: `shop/klassikere-111s1.html`, redirectTo: `` },
  { path: `shop/koldt-bord-375p.html`, redirectTo: `` },
  { path: `shop/koldt-bord-stor-376p.html`, redirectTo: `` },
  { path: `shop/luksus-120c1.html`, redirectTo: `` },
  { path: `shop/luksus-menu-med-330p.html`, redirectTo: `` },
  { path: `shop/madbroed-293p.html`, redirectTo: `` },
  { path: `shop/mexicansk-tema-301p.html`, redirectTo: `` },
  { path: `shop/nytaarsmenu-281p.html`, redirectTo: `` },
  { path: `shop/oel-tema-menu-377p.html`, redirectTo: `` },
  { path: `shop/pulled-pork-burger-400p.html`, redirectTo: `` },
  { path: `shop/paaske-tilbud-123c1.html`, redirectTo: `` },
  { path: `shop/paaske-tilbud-452p.html`, redirectTo: `` },
  { path: `shop/receptionsmenu-295p.html`, redirectTo: `` },
  { path: `shop/receptionsmenu-296p.html`, redirectTo: `` },
  { path: `shop/receptionsmenu-366p.html`, redirectTo: `` },
  { path: `shop/sandwich-372p.html`, redirectTo: `` },
  { path: `shop/showbasket.html`, redirectTo: `` },
  { path: `shop/sommer-studentertilbud-381p.html`, redirectTo: `` },
  { path: `shop/spagetti-351p.html`, redirectTo: `` },
  { path: `shop/tunmousse-med-stenbiderrogn-443p.html`, redirectTo: `` },
  { path: `shop/vaelg-en-laekker-412p.html`, redirectTo: `` },
  { path: `shop/vaelg-en-laekker-413p.html`, redirectTo: `` },
];
